module.exports = __webpack_public_path__ + "static/media/veterans_logo.e43d88fa.jpg";